import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import FinancialModeling from './FinancialModeling';
import AnalyticRatio from './AnalyticRatio';
import Valutation from './Valuation';

const useStyles = makeStyles({
  root: {
    width: '80%%',
    margin: '1rem auto',
    borderRadius: 0,

    '& button': {
      textTransform: 'capitalize'
    },

    '& .Mui-selected': {
      fontWeight: 'bold',
      background: '#002380',
      color: '#FAFAFA',
      margin: '3px',
      transition: 'color 0.2s cubic-bezier(0.4, 0, 0.2, 1) 0ms'
    }
  },
  content: {
    width: '100%',
    margin: '0 auto'
    // padding: '3rem'
  }
});

const FinancialModelNav = () => {
  const classes = useStyles();
  const [value, setValue] = useState(0);

  const handleChange = (e, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Paper className={classes.root}>
        <Tabs
          centered
          indicatorColor="primary"
          onChange={handleChange}
          textColor="primary"
          value={value}>
          <Tab label="Financial modeling" />
          <Tab label="Analytic ratio" />
          <Tab label="Valuation" />
        </Tabs>
      </Paper>
      <div className={classes.content}>
        {value === 0 && <FinancialModeling />}
        {value === 1 && <AnalyticRatio />}
        {value === 2 && <Valutation />}
      </div>
    </>
  );
};

export default FinancialModelNav;
